export * from "./store-marker.component";
